import { getGraphqlApolloRouterBaseUrl } from './getGraphqlApolloRouterBaseUrl';
import { createApi } from '@reduxjs/toolkit/query/react';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { GraphQLClient } from 'graphql-request';

const graphEndpoint = getGraphqlApolloRouterBaseUrl();
// Authorization header will be added by useUpdateApiHeaders hook once the user is authenticated
export const client = new GraphQLClient(graphEndpoint);

// Store base headers (like Authorization) separately since headers is now a function
let baseHeaders: Record<string, string> = {};

// Get anonymousId directly from window.analytics to avoid circular dependency
const getAnonymousId = (): string | undefined => {
  const { analytics } = window;
  return analytics?.user?.()?.anonymousId?.();
};

// Set headers as a function that dynamically includes anonymousId
// This function is called on every request, ensuring anonymousId is always up-to-date
// It merges anonymousId with base headers (like Authorization)
client.requestConfig.headers = () => {
  // Include anonymousId if available
  const anonymousId = getAnonymousId();
  if (anonymousId) {
    return {
      ...baseHeaders,
      'x-segment-anonymous-id': anonymousId,
    };
  }

  return baseHeaders;
};

export const graphQlService = createApi({
  reducerPath: 'apolloApi',
  baseQuery: graphqlRequestBaseQuery({ client }),
  tagTypes: ['TenantUser'],
  endpoints: () => ({}),
});

export const updateGraphQLAuthHeader = (bearer: string) => {
  // Update base headers instead of using setHeaders (since headers is now a function)
  baseHeaders = {
    ...baseHeaders,
    Authorization: bearer,
  };
};
